import type { FaireProductEntity } from "../../entity_types/product";

export const p_ykr53mdpug: FaireProductEntity = {
  token: "p_ykr53mdpug",
  type: "product",
  name: "Boho Paisley Hair Bow Scrunchie - Hair Accessory for women",
  brandToken: "b_3mpqvcxzwd",
  brandName: "LadyJuneAccessories",
  imageUrl: "https://cdn.faire.com/fastly/9d2d145758a7c08c5de5ff0aa58b1824e83eaff454eeb5dca6b16fd2e9c075ca.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3c42704188ee4361b5a0ceaa8467128e6001b877e829a27ef89fc9eece3f1cf5.jpeg",
    "https://cdn.faire.com/fastly/d06caaff129e98e3a11562c944a0ee1d9761fd8da49fbd8399e34ad1082b7451.jpeg",
    "https://cdn.faire.com/fastly/291f4e2231a0b0b21dcce2ee4c2fd931609c8698ded3494bcec6ecd121eece6e.jpeg",
    "https://cdn.faire.com/fastly/5d88d63e6701c1d9f4bfcd205ce1e453fad4d9e76cccad6d3640565e794aa755.jpeg"
  ],
  priceDollars: 4.9,
  description: "\"Add a touch of bohemian elegance to your hairstyle with our Boho Paisley Hair Bow Scrunchie. This beautiful hair accessory combines the practicality of a scrunchie with the charm of a paisley-patterned bow, making it a perfect choice for any occasion. Whether you're dressing up for a special event or adding flair to your everyday look, this scrunchie will be your go-to accessory.\n\nKey Features:\n\nBoho Paisley Design: The intricate paisley pattern adds a stylish and unique touch to your hair.\nBow Detail: The attached bow enhances the scrunchie's appearance, giving it a feminine and fashionable look.\nHigh-Quality Fabric: Made from soft, durable fabric that is gentle on your hair and provides a secure hold.\nVersatile Use: Ideal for ponytails, buns, or as a decorative wrist accessory.\nComfortable Fit: Elastic band ensures a snug yet comfortable hold for all hair types.",
  tags: [],
  msrpDollars: 9.8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:25.167Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
